import { combineReducers } from "redux";
import LoginReducer from "./Login/reducer";
import UserReducer from "./User/reducer";
import UplaoadFileReducer from "./Upload Image/reducer";
import ExportUserReducer from "./ExportUser/reducer";
import FaqReducer from "./Faq/reducer";
import ContentPageReducer from "./ContentPage/reducer";
import SystemAdminReducer from "./SystemAdmin/reducer";
import SettingReducer from "./Settings/reducer";
import CatalogReducer from "./Catalog/reducer";
import DashboardReducer from "./Dashboard/reducer";
import ExportReducer from "./Export/reducer";
import DocumentsReducer from "./Documents/reducer";
import TemplatesReducer from "./Templates/reducer";
import CategoryReducer from "./Category/reducer";
import EmailTempReducer from "./EmailTemp/reducer";
import SignatureReducer from "./Signature/reducer";
import DocumentCategoryReducer from "./DocumentCategory/reducer";
import DeleteSubscriberReducer from "./DeleteSubscriber/reducer";

const rootReducer = combineReducers({
  login: LoginReducer,
  Customers: UserReducer,
  Documents: DocumentsReducer,
  Templates: TemplatesReducer,
  fileUpload: UplaoadFileReducer,
  ExportUser: ExportUserReducer,
  FaqReducer: FaqReducer,
  ContentPageReducer: ContentPageReducer,
  SystemAdmin: SystemAdminReducer,
  Setting: SettingReducer,
  Catalog: CatalogReducer,
  Dashboard: DashboardReducer,
  Export: ExportReducer,
  Categories: CategoryReducer,
  DocumentCategories: DocumentCategoryReducer,
  EmailTemplates: EmailTempReducer,
  Signatures: SignatureReducer,
  Subscribers: DeleteSubscriberReducer,
});

export default rootReducer;
